import React from 'react'
import i18n from '~/i18n'

export default function AutomationOptionChatClosed({ inboxes, stepOptions }) {
    const inbox = inboxes.find((i) => i.id === stepOptions.InboxId?.value)
    const name = stepOptions.InboxId?.value == -1 ? 'Any Inbox' : inbox?.name || 'NOT FOUND'
    const users = []
    for (const inbox of inboxes) {
        if (stepOptions.InboxId?.value > -1 && inbox.id !== stepOptions.InboxId?.value) {
            continue
        }
        for (const user of inbox.AccountUsers) {
            if (!users.some((u) => u.value === user.id)) {
                users.push({
                    value: user.id,
                    label: user.firstName + ' ' + user.lastName + ' (' + user.emailAddress + ')'
                })
            }
        }
    }
    let username = 'Any User'
    if (stepOptions.AssignedUserId?.value && stepOptions.AssignedUserId?.value > -1) {
        const user = users.find((u) => u.value === stepOptions.AssignedUserId?.value)
        username = user ? user.label : 'NOT FOUND'
    }

    return (
        <span
            dangerouslySetInnerHTML={{
                __html: i18n.t('automation:add.initial.render21', { inbox: name, user: username })
            }}
        ></span>
    )
}
